import React from "react";
import { Link } from "react-router-dom";

import { NetworkBackground } from "./app/components/NetworkBackground";

export default function ErrorPage() {
  return (
    <div className="grid h-screen w-screen content-center justify-center">
      <NetworkBackground />
      <div className="mb-56 rounded-xl bg-gray-200 p-8 shadow-lg">
        <h1 className="p-8 text-center text-2xl">We’re Sorry, an error occurred.</h1>
        <br />
        <Link
          onClick={() => window.location.reload(true)}
          className="center mx-auto block rounded-md p-2 text-center text-2xl text-purple-800 hover:bg-purple-600 hover:text-white"
        >
          Refresh Page
        </Link>
      </div>
    </div>
  );
}
